import React from "react";
import Inicio from "./pages/Inicio";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./App.css";
import Menu from "./components/Menu";
// import { CustomPreloader } from 'react-preloaders';
// import PreLoader from "./components/PreLoader";
import { Route, Switch } from "react-router-dom";
import MensajesVirgenEs from "./pages/MensajesVirgenEs";
import MensajesVirgenFr from "./pages/MensajesVirgenFr";
import MensajesVirgenGer from "./pages/MensajesVirgenGer";
import MensajesVirgenEn from "./pages/MensajeVirgenEn";
import MensajesJesus from "./pages/MensajesJesus";
import MensajeCentral from "./pages/MensajeCentral";
import Consagraciones from "./pages/Consagraciones";
import PedidosOracion from "./pages/PedidosOracion";
import Devocionario from "./pages/Devocionario";
import HistoriaAparicion from "./pages/HistoriaAparicion";
import PreguntasFrec from "./pages/PreguntasFrec";
import SantoRosario from "./pages/SantoRosario";
import ScrollToTop from "./components/ScrollToTop";
import BarraBotones from "./components/BarraBotones";

function App() {
  return (
    // <div style={{ overflow: "hidden" }} className="App">
    <div className="App">
      <Menu />
      <Route>
        <ScrollToTop></ScrollToTop>
      </Route>
      <Switch>
        <Route path="/" exact>
          <Inicio />
        </Route>
        <Route path="/mensajes-virgen/es" exact>
          <MensajesVirgenEs />
        </Route>
        <Route path="/mensajes-virgen/fr" exact>
          <MensajesVirgenFr />
        </Route>
        <Route path="/mensajes-virgen/ger" exact>
          <MensajesVirgenGer />
        </Route>
        <Route path="/mensajes-virgen/en" exact>
          <MensajesVirgenEn />
        </Route>
        <Route path="/mensajes-jesus" exact>
          <MensajesJesus />
        </Route>
        <Route path="/mensaje-central" exact>
          <MensajeCentral />
        </Route>
        <Route path="/consagraciones" exact>
          <Consagraciones />
        </Route>
        <Route path="/santo-rosario" exact>
          <SantoRosario />
        </Route>
        <Route path="/pedidos-oracion" exact>
          <PedidosOracion />
        </Route>
        <Route path="/historia-aparicion" exact>
          <HistoriaAparicion />
        </Route>
        <Route path="/preguntas-frec" exact>
          <PreguntasFrec />
        </Route>
        <Route path="/devocionario" exact>
          <Devocionario />
        </Route>
      </Switch>
      <BarraBotones />
      {/* <PreLoader /> */}
    </div>
  );
}

export default App;
